import * as React from 'react';
import type { SVGProps } from 'react';
const SvgBars = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={297}
    height={252}
    fill="none"
    {...props}
  >
    <path
      fill="#E2E2EB"
      fillRule="evenodd"
      d="M61.362 192.498h42.553v-56.075c0-6.715-5.443-12.158-12.158-12.158H73.52c-6.714 0-12.158 5.443-12.158 12.158zM128.231 192.499h42.553V98.213c0-6.715-5.443-12.158-12.158-12.158h-18.237c-6.714 0-12.158 5.443-12.158 12.158zM195.1 192.498h42.553V73.648c0-6.715-5.444-12.158-12.158-12.158h-18.237c-6.715 0-12.158 5.443-12.158 12.158z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgBars;
